// @ts-nocheck

import { FunctionalComponent, h } from "preact";
import { useCallback, useEffect, useState } from "preact/hooks";
import useScrollBottom from "react-scroll-bottom-hook";

import { fetchImages } from "../services/reddit_pjson_api";

import { Bar } from "./Bar";
import { Tags } from "./Tags";
import { Image } from "./Image";
import { ImageGrid } from "./ImageGrid";
import { Gallery } from "./Gallery";
import { RadioButtons } from "./RadioButtons";
import { LoadingIndicator } from "./LoadingIndicator";

// utility
const isLastIndex = (arr: any[], index: number) => arr.length === index + 1;

const fetchData = async (
  subreddits: string[],
  after: string = "",
  filter: string = "top",
  time: string = "all"
) => {
  if (!subreddits.length) return;
  console.log("fetching", subreddits, filter, after);
  return fetchImages({
    subreddit: subreddits.join("+"),
    count: 25,
    after,
    filter,
    time,
  });
};

enum DisplayModes {
  MASONRY = "masonry",
  FULLSCREEN = "fullscreen",
}

function presetSubreddits() {
  const defaultSubs = ["analog"];

  const urlParams = new URLSearchParams(location.search);
  const subreddits = urlParams.get("r");

  return subreddits ? subreddits.split(" ") : defaultSubs;
}

const App: FunctionalComponent = () => {
  const [imagePages, setImagePages] = useState([]);
  const [filter, setFilter] = useState("top");
  const [time, setTime] = useState("all");
  const [columns, setColumns] = useState("fluid");

  const [isLoading, setLoading] = useState(true);
  const [isNextPageLoading, setNextPageLoading] = useState(false);
  const [subreddits, setSubreddits] = useState(presetSubreddits);
  const [displayMode, setDisplayMode] = useState(DisplayModes.MASONRY);

  const [isBottom, scrollRef] = useScrollBottom();
  // const isBottom = false;

  const fetchImages = async (
    subreddits: string[],
    after: string = "",
    filter: string
  ) => {
    const newImagePage = await fetchData(subreddits, after, filter, time);
    // @ts-ignore
    setImagePages([...imagePages, newImagePage]);
    setLoading(false);
  };

  // @ts-ignore
  useEffect(async () => {
    if (isBottom) {
      setNextPageLoading(true);
      await fetchImages(subreddits, getLastPostName(imagePages), filter);
      setNextPageLoading(false);
    }
    return () => {};
  }, [isBottom]);

  const handleFilterChange = ({ value }) => {
    setImagePages([]);
    if (value.time) setTime(value.time);
    setFilter(value.filter);
  };

  // const handleSubredditsUpdate = useCallback(
  //   async (subreddits: string[]) => {
  //     console.log("update subreddits", subreddits);
  //     setSubreddits(subreddits);
  //     setImagePages([]);
  //     await fetchImages(subreddits);
  //     history.replaceState(null, "", `?subreddits=${subreddits.join("+")}`);
  //   },
  //   [subreddits]
  // );

  useEffect(() => {
    setLoading(true);
    console.log("initial load");
    fetchImages(subreddits, undefined, filter);
  }, [subreddits, filter, time]);

  console.log({ imagePages, displayMode, columns, time, filter, subreddits });
  console.log({ isBottom });

  return (
    <div id="app">
      <Bar>
        Filter:
        <RadioButtons
          onSelect={handleFilterChange}
          initial="TOP"
          disableReselect
          options={[
            { label: "TOP", value: { filter: "top", time: "all" } },
            { label: "TOP 1M", value: { filter: "top", time: "month" } },
            { label: "HOT", value: { filter: "hot" } },
          ]}
        />
        Display:
        <RadioButtons
          onSelect={setColumns}
          initial="Fluid"
          disableReselect
          transformValue={({ value }) => value}
          options={[
            { label: "2", value: "2" },
            { label: "3", value: "3" },
            { label: "Fluid", value: "fluid" },
          ]}
        />
        Subs:
        <Tags initialTags={subreddits} />
      </Bar>
      <Gallery ref={scrollRef}>
        {isLoading ? (
          <LoadingIndicator fixedCenter />
        ) : (
          imagePages
            .filter((p) => !!p)
            .map((imagePage: any[], pageIndex: number) => (
              <ImageGrid
                key={pageIndex}
                displayMode={displayMode}
                columns={columns}
              >
                {imagePage.map((post: any, postIndex: number) => (
                  <Image
                    displayMode={displayMode}
                    key={post.data.url + "_" + postIndex}
                    src={post.data.url}
                    thumbnail={post.data.thumbnail}
                  />
                ))}
              </ImageGrid>
            ))
        )}
        {isNextPageLoading && <LoadingIndicator fixedBottom />}
      </Gallery>
      {/* <button
                onClick={() =>
                    fetchImages(subreddits, getLastPostName(imagePages))
                }
            >
                load more...
             if(!imagePages.length) {
        return (<div>zero pages</div>)
    }   </button> */}
    </div>
  );
};

export default App;

function getLastPostName(imagePages: any[]) {
  const lastPage = imagePages[imagePages.length - 1];
  const lastPost = lastPage[lastPage.length - 1];
  return lastPost.data.name;
}
